// extracted by mini-css-extract-plugin
module.exports = {"content__tag":"styles_content__tag__e91gg","pulse":"styles_pulse__1KxNX","jump":"styles_jump__NdVby","wiggle":"styles_wiggle__lSjZ7"};